"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unformat_1 = __importDefault(require("./unformat"));
function isValid(value) {
    const unformatted = unformat_1.default(value);
    if (/^0+/.test(unformatted)) {
        return false;
    }
    let remainer = parseInt(unformatted.slice(0, -1), 10);
    let module = 1;
    let counter = 0;
    while (remainer > 0) {
        module = (module + (remainer % 10) * (9 - counter++ % 6)) % 11;
        remainer = Math.floor(remainer / 10);
    }
    const verifier = module > 0 ? '' + (module - 1) : 'K';
    return verifier === unformatted.slice(-1);
}
exports.default = isValid;
//# sourceMappingURL=isValid.js.map